/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Change User ServiceAccess Page component
 *
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.11.0
 */

import { useEffect } from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { changeUserServiceAccessAction } from '../PageAuth/actions/authServiceAccessActions';

const ChangeUserServiceAccessPage = (props: IDispatchToProps) => {
    const { changeUserServiceAccess } = props;

    useEffect(() => {
        changeUserServiceAccess();
    }, [changeUserServiceAccess]);

    // We can show some info while logout processing
    return null;
};

interface IDispatchToProps {
    changeUserServiceAccess: () => void;
}

export const mapDispatchToProps = (dispatch: Dispatch): IDispatchToProps => ({
    changeUserServiceAccess: () => dispatch(changeUserServiceAccessAction()),
})

export default connect(null, mapDispatchToProps)(ChangeUserServiceAccessPage);
